import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setLoading } from "../loading/loadingSlice";
import { setError, clearError } from "../error/errorSlice";

import {
  fetchBuildings as fetchBuildingsWithSort,
  fetchAllBuildings as fetchAllBuildingsFromAPI,
} from "../../pages/setup/components/Building/services/buildingService";

const initialState = {
  buildings: [],
  allBuildings: [],
  loading: false,
  error: null,
  totalPages: 1,
};

export const fetchBuildings = createAsyncThunk(
  "buildings/fetchBuildings",
  async (
    { currentPage, rowsPerPage, searchQuery, sortField, sortOrder },
    thunkAPI
  ) => {
    const { dispatch } = thunkAPI;
    try {
      dispatch(setLoading(true));
      dispatch(clearError());
      const data = await fetchBuildingsWithSort(
        currentPage,
        rowsPerPage,
        searchQuery,
        sortField,
        sortOrder
      );
      return data;
    } catch (error) {
      dispatch(setError(error.message));
      return thunkAPI.rejectWithValue(error.message);
    } finally {
      dispatch(setLoading(false));
    }
  }
);

export const fetchAllBuildings = createAsyncThunk(
  "buildings/fetchAllBuildings",
  async (_, thunkAPI) => {
    const { dispatch } = thunkAPI;
    try {
      dispatch(setLoading(true));
      dispatch(clearError());
      const data = await fetchAllBuildingsFromAPI();
      return data; // expecting an array of buildings
    } catch (error) {
      dispatch(setError(error.message));
      return thunkAPI.rejectWithValue(error.message);
    } finally {
      dispatch(setLoading(false));
    }
  }
);

const buildingsSlice = createSlice({
  name: "buildings",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBuildings.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBuildings.fulfilled, (state, action) => {
        state.buildings = action.payload.content;
        state.totalPages = action.payload.totalPages;
      })
      .addCase(fetchBuildings.rejected, (state, action) => {
        state.error = action.payload;
      })
      .addCase(fetchAllBuildings.fulfilled, (state, action) => {
        state.allBuildings = action.payload;
      });
  },
});

export const selectBuildings = (state) => state.buildings.buildings;
export const selectAllBuildings = (state) => state.buildings.allBuildings;
export const selectTotalPages = (state) => state.buildings.totalPages;
export const selectLoading = (state) => state.buildings.loading;

export default buildingsSlice.reducer;
